import { Box } from "@chakra-ui/react";
import { matchHeadFontCss } from "containers/MatchContainer/MatchContainer";
import { colors, getCdnImageSrc, Image, useResponsive, VStack } from "goi_common";
import React, { ReactNode } from "react";

export default function MatchPRSection() {
  const { isBiggerThanLg, isBiggerThanMd } = useResponsive();
  return (
    <>
      <MatchPRHead
        tag="맞춤형 견적"
        title={
          <>
            맞춤형 견적을 받고
            <br />
            엄선된 장례지도사가 출동해요
          </>
        }
        description={
          <>
            우리 가족의 상황과{isBiggerThanMd || <br />} 장례식 예산에 따른 맞춤형 견적을 받고,
            엄선된 장례지도사가 출동합니다.
          </>
        }
      />
      <VStack
        width="100%"
        alignItems="center"
        padding="50px 0px"
        position="relative"
        background={colors.gray50}
      >
        <Image src={getCdnImageSrc("platform/match/match-pr-5.png")} alt="" width="298px" />
      </VStack>

      <MatchPRHead
        tag="합리적인 가격"
        title={
          <>
            하청 대신 직거래 구조로
            <br />
            장례 비용의 거품을 없애요
          </>
        }
        description={
          <>
            하청, 재하청으로 인한 가격 거품을 없애고, {isBiggerThanMd || <br />}소비자와 전문가가
            연결되도록 돕습니다.
          </>
        }
      />
      <VStack width="100%" alignItems="center" padding="50px 0px" background={colors.gray50}>
        <Image src={getCdnImageSrc("platform/match/match-pr-2.png")} alt="" width="298px" />
      </VStack>

      <MatchPRHead
        tag="서비스 품질"
        title={
          <>
            모든 장례에 책임감을 갖고,
            <br />
            서비스 품질을 100% 보증해요
          </>
        }
      />
      <Box
        display="flex"
        flexDir={isBiggerThanLg ? "row" : "column"}
        width="100%"
        padding={isBiggerThanLg ? "0px 24px 50px" : "0px 24px"}
        alignItems="center"
        justifyContent="center"
        gap="40px"
      >
        <VStack maxWidth={isBiggerThanMd ? "480px" : "100%"} gap={24}>
          <Image src={getCdnImageSrc("platform/match/match-pr-3.png")} alt="" width="100%" />
          <div>
            매칭이 이루어진 뒤에도 안심 장례 매니저가 24시간 대기하며 서비스를 책임져요. 파트너가
            제공하는 서비스에 대한 불편 사항을 듣고 적극 개입하여 문제를 해결해 드려요.
          </div>
        </VStack>
        <VStack maxWidth={isBiggerThanMd ? "480px" : "100%"} gap={24}>
          <Image src={getCdnImageSrc("platform/match/match-pr-4.png")} alt="" width="100%" />
          <div>
            또한 혹시 모를 상황에 대비하여 상주님의 돈을 안전하게 지켜드려요. 대금을 예치하고
            파트너에게 분할 정산함으로써 문제 발생 시 100% 환불을 보장해요.
          </div>
        </VStack>
      </Box>
    </>
  );
}

function MatchPRHead({
  tag,
  title,
  description,
}: {
  tag: string;
  title: ReactNode;
  description?: ReactNode;
}) {
  const { isBiggerThanLg, isBiggerThanMd } = useResponsive();
  return (
    <VStack
      gap="12px"
      alignItems={isBiggerThanMd ? "center" : "flex-start"}
      width="100%"
      css={{ textAlign: isBiggerThanMd ? "center" : "left" }}
      padding={isBiggerThanLg ? "80px 0px 60px" : "60px 24px 24px"}
    >
      <div className={isBiggerThanLg ? "head2_b orange700" : "subtitle3 orange700"}>{tag}</div>
      <div css={matchHeadFontCss}>{title}</div>
      {description && <div className={isBiggerThanLg ? "head2_m" : "body3_m"}>{description}</div>}
    </VStack>
  );
}
